<template lang="pug">
  b-container(fluid)
    .mb-4(v-if="$can('update', 'account')")
      b-form-row.align-items-end
        b-col
          b-form-group(label="Nombre de cuenta")
            b-form-input(placeholder="Nombre de cuenta", v-model="account_name")
        b-col(cols="auto")
          b-button(variant="primary", @click="updateName") Guardar


    .mb-4
      b-form-row.align-items-end
        b-col
          b-form-group(label="Relación de aspecto para imágenes en Messenger")
            b-form-select(:options="image_aspect_ratio_options", v-model="image_aspect_ratio" :disabled="image_aspect_ratio_loading")
        b-col(cols="auto")
          b-button(variant="primary", @click="updateImageAspectRatio") Guardar

    .mb-4(v-if="$can('read', 'account-timezone')")
      p.mb-0 Establecer zona horaria para la cuenta
        p.text-secondary.text-sm La zona horaria por default esta establecida en la Ciudad de México
      b-form-group(label="Zona horaria")
        treeselect(:options="time_zones", placeholder="- Seleccionar zona horaria -", v-bind="treeselect_options", :disable-branch-nodes="true", v-model="timezone_id", @select="setTimezone", :clearable="false")
    p.mb-0 Actualizar dashboard a la última versión
    p.text-secondary.text-sm Si no ves funcionalidades nuevas, probablemente necesites forzar actualizar el dashboard
    b-button.mb-3(variant="primary", @click="updateDashboard")
      .d-flex.align-items-center
        rotate-ccw-icon.icon-sm.mr-2
        span Actualizar dashboard
    hr
    b-card.bg-light.mb-0.no-shadow.mt-3.mt-md-5(v-if="$can('delete', 'account')")
      h5.mb-3
        alert-triangle-icon.icon-sm.mr-2
        span Zona peligrosa
      p.mb-0 Eliminar cuenta de forma permanente.
      p.text-secondary Se borrarán todos los flujos y entrenamiento de la cuenta. Esta acción no se puede deshacer.
      b-button(variant="soft-danger", @click="confirmDelete") Eliminar cuenta
</template>

<script>
  import { mapActions, createNamespacedHelpers } from 'vuex'
  import treeselectOptions from '@/data/treeselect-options'

  export default {
    data () {
      return {
        time_zones: [
          {
            id: 'Africa',
            label: 'Africa',
            children: []
          },
          {
            id: 'America',
            label: 'America',
            children: []
          },
          {
            id: 'Asia',
            label: 'Asia',
            children: []
          },
          {
            id: 'Australia',
            label: 'Australia',
            children: []
          },
          {
            id: 'Europe',
            label: 'Europe',
            children: []
          },
          {
            id: 'Atlantic',
            label: 'Atlantic',
            children: []
          },
          {
            id: 'Indian',
            label: 'Indian',
            children: []
          },
          {
            id: 'Pacific',
            label: 'Pacific',
            children: []
          },
        ],
        timezone_id: null,
        treeselect_options: treeselectOptions,
        account_name: '',
        image_aspect_ratio_loading: false,
        image_aspect_ratio: null,
        image_aspect_ratio_options: [
          {value: 'horizontal', text: 'Horizontal (1.91:1)'},
          {value: 'square', text: 'Cuadrada (1:1)'},
        ]
      }
    },
    methods: {
      ...mapActions([
        'account/get',
        'account/update',
        'account/destroy'
      ]),
      updateDashboard() {
        this.showLoadingScreen()
        // some suspense...
        setTimeout(function () {
          window.location.reload(true)
        }, 2000)
      },
      getAccount() {
        this['account/get']({
          account_id: this.$route.params.account_id,
          callback: res => {
            if (res.error) return this.$message.error(res.error)

            this.account_name = res.resource.name
            this.timezone_id = res.resource.timezone || this.$moment.tz.guess()
          }
        })
      },
      async getImageAspectRatio() {
        try {
          this.image_aspect_ratio_loading = true
          const accountID = this.$route.params.account_id
          const {data} = await this.$request.get(`/account/${accountID}/configuration`)

          if (data.success) {
            this.image_aspect_ratio = data.resource.image_aspect_ratio
          } else {
            this.$message.warning('No se pudo obtener la relación de aspecto para las imágenes')
          }
        } catch {
          this.$message.warnng('Ha ocurrido un error con los servicios al obtener la relación de aspecto para las imágenes')
        } finally {
          this.image_aspect_ratio_loading = false
        }
      },
      async updateImageAspectRatio() {
        try {
          this.image_aspect_ratio_loading = true
          const accountID = this.$route.params.account_id
          const {data} = await this.$request.patch(`/account/${accountID}/configuration`, {image_aspect_ratio: this.image_aspect_ratio})

          if (data.success) {
            this.$message.success('Se ha actualizado la relación de aspecto para las imágenes')
          } else {
            this.$message.warning('No se pudo actualizar la relación de aspecto para las imágenes. Intenta más tarde')
          }
        } catch {
          this.$message.warning('Ha ocurrido un error con los servicios al actualizar la relación de aspecto para las imágenes')
        } finally {
          this.image_aspect_ratio_loading = false
        }
      },
      setTimezone(zone) {
        this['account/update']({
          account_id: this.$route.params.account_id,
          timezone: zone.id,
          callback: res => {
            if (res.error) return this.$message.error(res.error)

            this.$message.success('Zona horaria actualizada')
          }
        })
      },
      updateName () {
        var self = this

        this['account/update']({
          account_id: self.$route.params.account_id,
          name: this.account_name,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.$message.success('Nombre actualizado')
              self.getAccount()
            }
          }
        })
      },
      confirmDelete () {
        this.$bvModal.msgBoxConfirm(`Se eliminará la cuenta de forma permanente. ¿Deseas continuar?`, {
          title: 'Eliminar cuenta ' + this.account_name,
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
        })
        .then(value => {
          if (value == true) {
            this.deleteAccount()
          }
        })
        .catch(err => {
          this.$message.warning('Error al eliminar la cuenta.', 'warning')
        })
      },
      deleteAccount () {
        var self = this
        this['account/destroy']({
          account_id: self.$route.params.account_id,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.$message.success('Cuenta eliminada')
              self.$router.push({name: 'root'}).catch(()=>{});
            }
          }
        })
      }
    },
    mounted() {
      let regex = /^((Africa|America|Antarctica|Asia|Australia|Europe|Arctic|Atlantic|Indian|Pacific)\/.+)$/
      let zone_names = this.$moment.tz.names().filter(zn => zn.match(regex)).map(zn => { return zn.split('/') })

      for (let i = 0; i < this.time_zones.length; i++) {
        let zone = this.time_zones[i]

        zone_names.forEach(name => {
          if(name.length <= 2 && name[0] == zone.id){
            zone.children.push({
              id: name[0] + '/' + name[1],
              label: name[1],
            })
          }
        })
      }

      this.getAccount()
      this.getImageAspectRatio()
    }
  }
</script>

<style lang="scss" scoped>
</style>
